


// import React, { useState, useEffect } from "react";
// import {
//   Layout, Menu, Table, Card, Descriptions, Modal, Form, InputNumber,
//   Select, Tag, message, Button, Tabs, Row, Col, Image, Statistic, Space,
//   Badge
// } from "antd";
// import {
//   DashboardOutlined,
//   UserOutlined,
//   TeamOutlined,
//   BookOutlined,
//   CheckCircleOutlined,
//   CloseCircleOutlined,
//   EyeOutlined,
//   DollarOutlined,
//   SettingOutlined,
//   FileImageOutlined,
//   ContactsOutlined,
//   RiseOutlined,
//   FallOutlined,
//   ShoppingCartOutlined,
//   UserAddOutlined,
//   TrophyOutlined, AppstoreOutlined
//   , MailOutlined, DeleteOutlined, CopyOutlined, ClockCircleOutlined, EditOutlined
//   , VideoCameraOutlined,
//   EyeInvisibleOutlined,
//   SafetyCertificateOutlined
// } from "@ant-design/icons";
// import courseService from "../../services/course.service";
// import PlanManager from "../moderateur/PlanManager";
// import NewsManager from "../moderateur/NewsManager";
// import SalesRequestManager from "../moderateur/SalesRequestManager";
// import InstructorRequestManager from "../moderateur/InstructorRequestManager";
// import CategoryManager from "../moderateur/CategoryManager";
// import UserManagement from "../admin/UserManagement";
// import CourseEditModal from "./CourseEditModal";
// import LiveTrainingsAdmin from "./live-trainings/LiveTrainingsAdmin";
// // ✅ Imports des composants Certificats (exactement comme ModeratorCourses)
// import ManualCertificateGenerator from "../moderateur/ManualCertificateGenerator";
// import CertificateGenerator from "../moderateur/CertificateGenerator";


// const { Header, Content, Footer, Sider } = Layout;
// const { Option } = Select;
// const { TabPane } = Tabs;

// const BoardAdmin = () => {
//   const [selectedMenu, setSelectedMenu] = useState("dashboard");
//   const [courses, setCourses] = useState([]);
//   const [pendingCourses, setPendingCourses] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [modalVisible, setModalVisible] = useState(false);
//   const [selectedCourse, setSelectedCourse] = useState(null);
//   const [activeTab, setActiveTab] = useState("1");
//   const [form] = Form.useForm();
//   const [isManagementModalVisible, setIsManagementModalVisible] = useState(false);
//   const [editModalVisible, setEditModalVisible] = useState(false);
//   const [editingCourseId, setEditingCourseId] = useState(null);
//   const [purchases, setPurchases] = useState([]);
//   const [purchaseStats, setPurchaseStats] = useState(null);
//   const [instructors, setInstructors] = useState([]);
//   const [students, setStudents] = useState([]);
//   const [userStats, setUserStats] = useState(null);

//   const [planPurchases, setPlanPurchases] = useState([]);
//   const [planPurchaseStats, setPlanPurchaseStats] = useState(null);

//   // ✅ NOUVEAU : Modal Certificats (reproduit exactement le pattern ModeratorCourses)
//   //    Pas besoin de sélecteur de cours : CertificateGenerator charge automatiquement
//   //    le dernier template existant en BDD via son useEffect interne
//   const [isCertificatesModalVisible, setIsCertificatesModalVisible] = useState(false);

//   useEffect(() => {
//     if (selectedMenu === "courses") {
//       loadAllCourses();
//     } else if (selectedMenu === "pending-courses") {
//       loadPendingCourses();
//     } else if (selectedMenu === "purchases") {
//       loadPurchases();
//     } else if (selectedMenu === "instructors") {
//       loadInstructors();
//     } else if (selectedMenu === "students") {
//       loadStudents();
//     } else if (selectedMenu === "plan-purchases") {
//       loadPlanPurchases();
//     } else if (selectedMenu === "manual-certificates") {
//       // ✅ Charger les cours + ouvrir la modal
//       loadAllCourses();
//       setIsCertificatesModalVisible(true);
//       // Reset au menu précédent pour pouvoir rouvrir la modal
//       setTimeout(() => setSelectedMenu("dashboard"), 100);
//     }
//   }, [selectedMenu]);

//   const planPurchasesColumns = [
//     {
//       title: "ID",
//       dataIndex: "id",
//       key: "id",
//       width: 60,
//     },
//     {
//       title: "Date d'achat",
//       dataIndex: "purchasedAt",
//       key: "purchasedAt",
//       width: 150,
//       render: (date) => new Date(date).toLocaleDateString('fr-FR'),
//       sorter: (a, b) => new Date(a.purchasedAt) - new Date(b.purchasedAt),
//     },
//     {
//       title: "Utilisateur",
//       dataIndex: "username",
//       key: "username",
//       render: (text, record) => (
//         <div>
//           <div style={{ fontWeight: 'bold' }}>{text}</div>
//           <div style={{ fontSize: '12px', color: '#999' }}>{record.userEmail}</div>
//         </div>
//       ),
//     },
//     {
//       title: "Plan",
//       dataIndex: "planTitle",
//       key: "planTitle",
//       ellipsis: true,
//     },
//     {
//       title: "Montant",
//       dataIndex: "amountInDollars",
//       key: "amount",
//       width: 120,
//       render: (amount, record) => (
//         <span style={{ fontWeight: 'bold', color: '#52c41a' }}>
//           {amount.toFixed(2)} {record.currency}
//         </span>
//       ),
//     },
//     {
//       title: "Période",
//       dataIndex: "period",
//       key: "period",
//       width: 120,
//       render: (period) => (
//         <Tag color={period === 'ANNUAL' ? 'blue' : 'purple'}>
//           {period === 'ANNUAL' ? 'Annuel' : 'Trimestriel'}
//         </Tag>
//       ),
//     },
//     {
//       title: "Statut",
//       dataIndex: "status",
//       key: "status",
//       width: 100,
//       render: (status) => (
//         <Tag color={status === 'APPROVED' ? 'green' : 'red'}>
//           {status}
//         </Tag>
//       ),
//     },
//     {
//       title: "Activation",
//       dataIndex: "isActive",
//       key: "isActive",
//       width: 100,
//       render: (isActive) => (
//         <Tag color={isActive ? 'success' : 'default'}>
//           {isActive ? 'Actif' : 'Inactif'}
//         </Tag>
//       ),
//     },
//     {
//       title: "Jours restants",
//       dataIndex: "expiresAt",
//       key: "daysRemaining",
//       width: 120,
//       render: (expiresAt, record) => {
//         if (!expiresAt || !record.isActive) {
//           return <span style={{ color: '#999' }}>N/A</span>;
//         }

//         const now = new Date();
//         const expiry = new Date(expiresAt);
//         const daysLeft = Math.ceil((expiry - now) / (1000 * 60 * 60 * 24));

//         let color = 'green';
//         if (daysLeft <= 5) color = 'red';
//         else if (daysLeft <= 15) color = 'orange';

//         return (
//           <Tag color={color} style={{ fontWeight: 'bold' }}>
//             {daysLeft > 0 ? `${daysLeft} jours` : 'Expiré'}
//           </Tag>
//         );
//       },
//       sorter: (a, b) => {
//         if (!a.expiresAt) return 1;
//         if (!b.expiresAt) return -1;
//         return new Date(a.expiresAt) - new Date(b.expiresAt);
//       },
//     },
//     {
//       title: "Expire le",
//       dataIndex: "expiresAt",
//       key: "expiresAt",
//       width: 120,
//       render: (date) => date ? new Date(date).toLocaleDateString('fr-FR') : 'N/A',
//     },
//     {
//       title: "Email envoyé",
//       dataIndex: "accessEmailSent",
//       key: "accessEmailSent",
//       width: 100,
//       render: (sent) => (
//         <Tag color={sent ? 'green' : 'orange'}>
//           {sent ? 'Oui' : 'Non'}
//         </Tag>
//       ),
//     },
//     {
//       title: "Actions",
//       key: "actions",
//       width: 280,
//       fixed: 'right',
//       render: (_, record) => (
//         <Space direction="vertical" size="small">
//           <Space>
//             {!record.isActive && record.status === 'APPROVED' && (
//               <Button
//                 type="primary"
//                 size="small"
//                 icon={<CheckCircleOutlined />}
//                 onClick={() => handleActivatePlan(record.id)}
//                 style={{ background: '#52c41a', borderColor: '#52c41a' }}
//               >
//                 Activer
//               </Button>
//             )}

//             {record.isActive && (
//               <Button
//                 danger
//                 size="small"
//                 icon={<CloseCircleOutlined />}
//                 onClick={() => handleDeactivatePlan(record.id)}
//               >
//                 Désactiver
//               </Button>
//             )}

//             <Button
//               type="default"
//               size="small"
//               icon={<MailOutlined />}
//               onClick={() => handleResendEmail(record.id)}
//               disabled={!record.isActive}
//             >
//               Email
//             </Button>
//           </Space>
//         </Space>
//       ),
//     },
//   ];

//   const handleDeleteCourse = async (courseId, courseTitle) => {
//     const showDeletionChoiceModal = () => {
//       Modal.confirm({
//         title: `Supprimer le cours : ${courseTitle}`,
//         content: (
//           <div style={{ padding: '16px 0' }}>
//             <p style={{ marginBottom: 16, fontSize: '14px' }}>
//               Choisissez le type de suppression pour ce cours :
//             </p>

//             <div style={{ marginBottom: 12 }}>
//               <div style={{
//                 padding: '12px',
//                 border: '2px solid #1890ff',
//                 borderRadius: '8px',
//                 backgroundColor: '#f0f7ff',
//                 marginBottom: '12px'
//               }}>
//                 <div style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
//                   <span style={{ fontSize: '16px', marginRight: 8 }}>🔒</span>
//                   <strong style={{ color: '#1890ff' }}>Désactiver (Recommandé)</strong>
//                 </div>
//                 <small style={{ color: '#666', lineHeight: 1.4 }}>
//                   Le cours sera masqué mais restera dans la base de données.
//                   Il pourra être restauré plus tard si nécessaire.
//                 </small>
//               </div>

//               <div style={{
//                 padding: '12px',
//                 border: '2px solid #ff4d4f',
//                 borderRadius: '8px',
//                 backgroundColor: '#fff2f0'
//               }}>
//                 <div style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
//                   <span style={{ fontSize: '16px', marginRight: 8 }}>🗑️</span>
//                   <strong style={{ color: '#ff4d4f' }}>Supprimer définitivement</strong>
//                 </div>
//                 <small style={{ color: '#ff4d4f', lineHeight: 1.4 }}>
//                   Le cours et toutes ses données seront supprimés de la base de données.
//                   Cette action est irréversible !
//                 </small>
//               </div>
//             </div>
//           </div>
//         ),
//         icon: null,
//         okText: "Supprimer définitivement",
//         okType: "danger",
//         cancelText: "Désactiver",
//         width: 520,

//         onOk: async () => {
//           return new Promise((resolve, reject) => {
//             Modal.confirm({
//               title: "Confirmation suppression définitive",
//               content: (
//                 <div>
//                   <p style={{ marginBottom: 8 }}>
//                     Confirmez-vous la suppression définitive du cours <strong>"{courseTitle}"</strong> ?
//                   </p>
//                   <p style={{ color: '#ff4d4f', fontSize: '12px', fontWeight: 'bold' }}>
//                     Le processus se déroulera en 2 étapes automatiques :
//                   </p>
//                   <ol style={{ color: '#666', fontSize: '12px', marginLeft: 16 }}>
//                     <li>Désactivation logique du cours</li>
//                     <li>Suppression physique définitive</li>
//                   </ol>
//                 </div>
//               ),
//               icon: <DeleteOutlined style={{ color: '#ff4d4f' }} />,
//               okText: "Oui, supprimer définitivement",
//               okType: "danger",
//               cancelText: "Annuler",
//               onOk: async () => {
//                 try {
//                   setLoading(true);
//                   message.loading("Étape 1/2 : Désactivation du cours...", 0);
//                   const softDeleteResponse = await courseService.softDeleteCourse(courseId);
//                   await new Promise(resolve => setTimeout(resolve, 1000));
//                   message.loading("Étape 2/2 : Suppression définitive...", 0);
//                   const permanentDeleteResponse = await courseService.permanentlyDeleteCourse(courseId);
//                   message.destroy();
//                   message.success("Cours supprimé définitivement avec succès");

//                   if (selectedMenu === "courses") {
//                     loadAllCourses();
//                   } else if (selectedMenu === "pending-courses") {
//                     loadPendingCourses();
//                   }
//                   resolve();

//                 } catch (error) {
//                   message.destroy();
//                   if (error.response) {
//                     if (error.response.status === 400) {
//                       message.error(`Erreur backend : ${error.response.data}`);
//                     } else if (error.response.status === 403) {
//                       message.error("Accès refusé : permissions insuffisantes");
//                     } else {
//                       message.error(`Erreur HTTP ${error.response.status}: ${error.response.data}`);
//                     }
//                   } else if (error.request) {
//                     message.error("Erreur réseau : impossible de contacter le serveur");
//                   } else {
//                     message.error(`Erreur : ${error.message}`);
//                   }
//                   reject(error);
//                 } finally {
//                   setLoading(false);
//                 }
//               },
//               onCancel: () => resolve()
//             });
//           });
//         },

//         onCancel: async () => {
//           Modal.confirm({
//             title: "Confirmer la désactivation",
//             content: (
//               <div>
//                 <p>
//                   Le cours <strong>"{courseTitle}"</strong> sera désactivé et masqué aux utilisateurs.
//                 </p>
//                 <p style={{ color: '#1890ff', fontSize: '12px', marginTop: 8 }}>
//                   Vous pourrez le restaurer plus tard depuis la section "Cours supprimés".
//                 </p>
//               </div>
//             ),
//             icon: <EyeOutlined style={{ color: '#1890ff' }} />,
//             okText: "Désactiver",
//             okType: "primary",
//             cancelText: "Annuler",
//             onOk: async () => {
//               try {
//                 setLoading(true);
//                 const response = await courseService.softDeleteCourse(courseId);
//                 message.success("Cours désactivé avec succès");
//                 if (selectedMenu === "courses") {
//                   loadAllCourses();
//                 } else if (selectedMenu === "pending-courses") {
//                   loadPendingCourses();
//                 }
//               } catch (error) {
//                 message.error("Erreur lors de la désactivation");
//               } finally {
//                 setLoading(false);
//               }
//             }
//           });
//         }
//       });
//     };

//     showDeletionChoiceModal();
//   };

//   const loadPlanPurchases = async () => {
//     setLoading(true);
//     try {
//       const data = await courseService.getAllPlanPurchases();
//       setPlanPurchases(data);
//       const stats = await courseService.getPlanPurchaseStats();
//       setPlanPurchaseStats(stats);
//     } catch (error) {
//       message.error("Erreur lors du chargement des achats de plans");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const loadAllCourses = async () => {
//     setLoading(true);
//     try {
//       const data = await courseService.getAllCoursesForAdmin();
//       setCourses(data);
//     } catch (error) {
//       message.error("Erreur lors du chargement des cours");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const loadPendingCourses = async () => {
//     setLoading(true);
//     try {
//       const data = await courseService.getPendingCourses();
//       setPendingCourses(data);
//     } catch (error) {
//       message.error("Erreur lors du chargement des cours en attente");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleActivatePlan = async (purchaseId) => {
//     Modal.confirm({
//       title: "Activer ce plan ?",
//       content: "Le compteur de durée sera lancé et un email d'accès sera envoyé à l'utilisateur.",
//       okText: "Activer",
//       cancelText: "Annuler",
//       onOk: async () => {
//         try {
//           setLoading(true);
//           const response = await courseService.activatePlanPurchase(purchaseId);
//           if (response.success) {
//             message.success(response.message);
//           } else {
//             message.warning("Plan activé mais vérifiez la configuration email");
//           }
//           await loadPlanPurchases();
//         } catch (error) {
//           message.error("Erreur lors de l'activation du plan");
//         } finally {
//           setLoading(false);
//         }
//       },
//     });
//   };

//   const handleDeactivatePlan = async (purchaseId) => {
//     Modal.confirm({
//       title: "Désactiver ce plan ?",
//       content: "L'utilisateur perdra l'accès au plan.",
//       okText: "Désactiver",
//       okType: "danger",
//       cancelText: "Annuler",
//       onOk: async () => {
//         try {
//           setLoading(true);
//           await courseService.deactivatePlanPurchase(purchaseId);
//           message.success("Plan désactivé avec succès");
//           loadPlanPurchases();
//         } catch (error) {
//           message.error("Erreur lors de la désactivation du plan");
//         } finally {
//           setLoading(false);
//         }
//       },
//     });
//   };

//   const handleResendEmail = async (purchaseId) => {
//     try {
//       setLoading(true);
//       await courseService.resendPlanAccessEmail(purchaseId);
//       message.success("Email d'accès renvoyé avec succès");
//       loadPlanPurchases();
//     } catch (error) {
//       message.error("Erreur lors de l'envoi de l'email");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const loadPurchases = async () => {
//     setLoading(true);
//     try {
//       const data = await courseService.getAllPurchases();
//       setPurchases(data);
//       const stats = await courseService.getPurchaseStats();
//       setPurchaseStats(stats);
//     } catch (error) {
//       message.error("Erreur lors du chargement des paiements");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const loadInstructors = async () => {
//     setLoading(true);
//     try {
//       const data = await courseService.getAllInstructors();
//       setInstructors(data);
//       const stats = await courseService.getUserStats();
//       setUserStats(stats);
//     } catch (error) {
//       message.error("Erreur lors du chargement des instructeurs");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const loadStudents = async () => {
//     setLoading(true);
//     try {
//       const data = await courseService.getAllStudents();
//       setStudents(data);
//       const stats = await courseService.getUserStats();
//       setUserStats(stats);
//     } catch (error) {
//       message.error("Erreur lors du chargement des étudiants");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleToggleActivation = async (userId) => {
//     try {
//       await courseService.toggleUserActivation(userId);
//       message.success("Statut mis à jour avec succès");
//       if (selectedMenu === "instructors") loadInstructors();
//       if (selectedMenu === "students") loadStudents();
//     } catch (error) {
//       message.error("Erreur lors de la mise à jour du statut");
//     }
//   };

//   const handleDeleteUser = (userId) => {
//     Modal.confirm({
//       title: "Êtes-vous sûr de vouloir supprimer cet utilisateur ?",
//       content: "Cette action est irréversible",
//       onOk: async () => {
//         try {
//           await courseService.deleteUser(userId);
//           message.success("Utilisateur supprimé avec succès");
//           if (selectedMenu === "instructors") loadInstructors();
//           if (selectedMenu === "students") loadStudents();
//         } catch (error) {
//           message.error("Erreur lors de la suppression");
//         }
//       },
//     });
//   };

//   const handleApproveClick = (course) => {
//     setSelectedCourse(course);
//     form.setFieldsValue({
//       latestPrice: course.latest_price || 1,
//       beforePrice: course.before_price || 1,
//       accessTime: course.access_time || "À vie",
//     });
//     setModalVisible(true);
//   };

//   const handleApprove = async () => {
//     try {
//       const values = await form.validateFields();
//       await courseService.approveCourse(
//         selectedCourse.id,
//         values.latestPrice,
//         values.beforePrice,
//         values.accessTime
//       );
//       message.success("Cours approuvé avec succès !");
//       setModalVisible(false);
//       setSelectedCourse(null);
//       loadPendingCourses();
//       loadAllCourses();
//     } catch (error) {
//       message.error("Erreur lors de l'approbation du cours");
//     }
//   };

//   const handleReject = async (courseId) => {
//     Modal.confirm({
//       title: "Êtes-vous sûr de vouloir rejeter ce cours ?",
//       onOk: async () => {
//         try {
//           await courseService.rejectCourse(courseId);
//           message.success("Cours rejeté");
//           setSelectedCourse(null);
//           loadPendingCourses();
//           loadAllCourses();
//         } catch (error) {
//           message.error("Erreur lors du rejet du cours");
//         }
//       },
//     });
//   };

//   const handleUnapprove = async (course) => {
//     Modal.confirm({
//       title: `Masquer le cours : ${course.title}`,
//       content: (
//         <div>
//           <p style={{ marginBottom: 12 }}>
//             Le cours sera <strong>masqué au public</strong> mais restera disponible :
//           </p>
//           <ul style={{ marginLeft: 16, color: '#666' }}>
//             <li>✅ Le modérateur peut continuer à le modifier</li>
//             <li>✅ Le cours reste dans la base de données</li>
//             <li>❌ Les étudiants ne pourront plus le voir ni l'acheter</li>
//             <li>✅ Vous pourrez le réapprouver à tout moment</li>
//           </ul>
//         </div>
//       ),
//       icon: <EyeInvisibleOutlined style={{ color: '#fa8c16' }} />,
//       okText: "Masquer le cours",
//       okType: "warning",
//       cancelText: "Annuler",
//       width: 500,
//       onOk: async () => {
//         try {
//           setLoading(true);
//           await courseService.unapproveCourse(course.id);
//           message.success(`Cours "${course.title}" masqué avec succès`);
//           if (selectedMenu === "courses") {
//             loadAllCourses();
//           } else if (selectedMenu === "pending-courses") {
//             loadPendingCourses();
//           }
//         } catch (error) {
//           message.error("Erreur lors du masquage du cours");
//         } finally {
//           setLoading(false);
//         }
//       }
//     });
//   };

//   const handleViewDetails = async (course) => {
//     if (course.overview || course.requirements) {
//       setSelectedCourse(course);
//       setActiveTab("2");
//       return;
//     }

//     try {
//       setLoading(true);
//       const fullCourse = await courseService.getCourseDetails(course.id);
//       setSelectedCourse(fullCourse);
//       setActiveTab("2");
//     } catch (error) {
//       message.error("Erreur lors du chargement des détails");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const usersColumns = [
//     { title: "ID", dataIndex: "id", key: "id", width: 60 },
//     {
//       title: "Utilisateur",
//       dataIndex: "username",
//       key: "username",
//       render: (text, record) => (
//         <div>
//           <div style={{ fontWeight: 'bold' }}>{text}</div>
//           <div style={{ fontSize: '12px', color: '#999' }}>{record.email}</div>
//         </div>
//       ),
//     },
//     {
//       title: "Type",
//       dataIndex: "roles",
//       key: "roles",
//       render: (roles) => (
//         <>
//           {roles.map(role => {
//             let color = "blue";
//             if (role === "Student") color = "green";
//             if (role === "Instructor") color = "purple";
//             if (role === "Admin") color = "red";
//             return <Tag key={role} color={color}>{role}</Tag>;
//           })}
//         </>
//       ),
//     },
//     { title: "Cours créés", dataIndex: "coursesCount", key: "coursesCount", width: 120, render: (count) => count || 0 },
//     { title: "Cours achetés", dataIndex: "purchasesCount", key: "purchasesCount", width: 120, render: (count) => count || 0 },
//     {
//       title: "Statut",
//       key: "status",
//       width: 200,
//       render: (_, record) => (
//         <div>
//           <Tag color={record.isActivated ? "green" : "red"}>{record.isActivated ? "Actif" : "Inactif"}</Tag>
//           <Tag color={record.isEmailConfirmed ? "green" : "orange"}>{record.isEmailConfirmed ? "Email confirmé" : "Non confirmé"}</Tag>
//         </div>
//       ),
//     },
//     {
//       title: "Actions",
//       key: "actions",
//       width: 200,
//       fixed: 'right',
//       render: (_, record) => (
//         <Space>
//           <Button type={record.isActivated ? "default" : "primary"} size="small" onClick={() => handleToggleActivation(record.id)}>
//             {record.isActivated ? "Désactiver" : "Activer"}
//           </Button>
//           <Button danger size="small" onClick={() => handleDeleteUser(record.id)}>Supprimer</Button>
//         </Space>
//       ),
//     },
//   ];

//   const purchasesColumns = [
//     { title: "ID", dataIndex: "id", key: "id", width: 60 },
//     {
//       title: "Date", dataIndex: "purchasedAt", key: "purchasedAt", width: 180,
//       render: (date) => new Date(date).toLocaleString('fr-FR'),
//       sorter: (a, b) => new Date(a.purchasedAt) - new Date(b.purchasedAt),
//     },
//     {
//       title: "Utilisateur", dataIndex: "username", key: "username", ellipsis: true,
//       render: (text, record) => (
//         <div><div>{text}</div><div style={{ fontSize: '12px', color: '#999' }}>{record.userEmail}</div></div>
//       ),
//     },
//     { title: "Cours", dataIndex: "courseTitle", key: "courseTitle", ellipsis: true },
//     {
//       title: "Montant", dataIndex: "amountInDollars", key: "amount", width: 120,
//       render: (amount, record) => <span style={{ fontWeight: 'bold' }}>{amount.toFixed(2)} {record.currency}</span>,
//     },
//     { title: "Méthode", dataIndex: "paymentMethod", key: "paymentMethod", width: 100 },
//     {
//       title: "Statut", dataIndex: "status", key: "status", width: 120,
//       render: (status) => {
//         const colors = { 'succeeded': 'green', 'APPROVED': 'green', 'processing': 'blue', 'requires_payment_method': 'orange', 'canceled': 'red' };
//         return <Tag color={colors[status] || 'default'}>{status}</Tag>;
//       },
//     },
//     { title: "Référence", dataIndex: "paymentIntentId", key: "paymentIntentId", ellipsis: true, width: 200 },
//   ];

//   const coursesColumns = [
//     {
//       title: "ID", dataIndex: "id", key: "id", width: 60, align: 'center',
//       render: (id) => <Tag color="blue" style={{ fontWeight: 'bold' }}>#{id}</Tag>
//     },
//     {
//       title: "Cours", dataIndex: "title", key: "title", ellipsis: true,
//       render: (title, record) => (
//         <div>
//           <div style={{ fontWeight: 'bold', marginBottom: 4 }}>{title}</div>
//           <div style={{ fontSize: '12px', color: '#999' }}>{record.lessons} leçons • {record.duration}</div>
//         </div>
//       )
//     },
//     {
//       title: "Prix", key: "pricing", width: 120, align: 'center',
//       render: (_, record) => (
//         <div style={{ textAlign: 'center' }}>
//           <div style={{ fontSize: '16px', fontWeight: 'bold', color: '#52c41a' }}>${record.latest_price?.toFixed(2)}</div>
//           {record.before_price > record.latest_price && (
//             <div style={{ fontSize: '12px', color: '#999', textDecoration: 'line-through' }}>${record.before_price?.toFixed(2)}</div>
//           )}
//         </div>
//       )
//     },
//     {
//       title: "Accès", dataIndex: "access_time", key: "access_time", width: 100, align: 'center',
//       render: (access_time) => <Tag icon={<ClockCircleOutlined />} color={access_time === "À vie" ? "green" : "blue"}>{access_time}</Tag>
//     },
//     {
//       title: "Catégorie", dataIndex: "categoryLibelle", key: "category", ellipsis: true,
//       render: (category) => <Tag color="purple">{category}</Tag>
//     },
//     {
//       title: "Statut", dataIndex: "approved", key: "approved", width: 120, align: 'center',
//       render: (approved) => (
//         <Tag icon={approved ? <CheckCircleOutlined /> : <ClockCircleOutlined />} color={approved ? "success" : "warning"} style={{ fontWeight: 'bold' }}>
//           {approved ? "Approuvé" : "En attente"}
//         </Tag>
//       ),
//     },
//     {
//       title: "Actions", key: "actions", width: 400, fixed: 'right',
//       render: (_, record) => (
//         <Space wrap size={[4, 8]}>
//           <Button type="default" size="small" icon={<EyeOutlined />} onClick={() => handleViewDetails(record)} style={{ borderColor: '#1890ff', color: '#1890ff' }}>Détails</Button>
//           {!record.approved && (
//             <>
//               <Button type="primary" size="small" icon={<CheckCircleOutlined />} onClick={() => handleApproveClick(record)} style={{ background: '#52c41a', borderColor: '#52c41a', fontWeight: 'bold' }}>Approuver</Button>
//               <Button danger size="small" icon={<CloseCircleOutlined />} onClick={() => handleReject(record.id)} style={{ fontWeight: 'bold' }}>Rejeter</Button>
//             </>
//           )}
//           {record.approved && (
//             <>
//               <Button type="default" size="small" icon={<EditOutlined />} onClick={() => handleEditCourse(record.id)} style={{ borderColor: '#faad14', color: '#faad14' }}>Modifier</Button>
//               <Button type="default" size="small" icon={<EyeInvisibleOutlined />} onClick={() => handleUnapprove(record)} style={{ borderColor: '#fa8c16', color: '#fa8c16', fontWeight: 'bold' }}>Masquer</Button>
//             </>
//           )}
//           <Button danger size="small" icon={<DeleteOutlined />} onClick={() => handleDeleteCourse(record.id, record.title)} style={{ background: '#ff4d4f', borderColor: '#ff4d4f', color: 'white', fontWeight: 'bold' }}>Supprimer</Button>
//         </Space>
//       ),
//     },
//   ];

//   const handleEditCourse = (courseId) => {
//     setEditingCourseId(courseId);
//     setEditModalVisible(true);
//   };

//   const renderPurchasesContent = () => {
//     return (
//       <div>
//         {purchaseStats && (
//           <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
//             <Col xs={24} sm={12} lg={6}>
//               <Card bordered={false} style={{ borderLeft: '4px solid #1890ff', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
//                 <Statistic title="Total Paiements" value={purchaseStats.totalPurchases} prefix={<ShoppingCartOutlined style={{ color: '#1890ff' }} />} valueStyle={{ color: '#1890ff' }} />
//               </Card>
//             </Col>
//             <Col xs={24} sm={12} lg={6}>
//               <Card bordered={false} style={{ borderLeft: '4px solid #52c41a', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
//                 <Statistic title="Revenu Total" value={purchaseStats.totalRevenue.toFixed(2)} prefix={<DollarOutlined style={{ color: '#52c41a' }} />} suffix="$" valueStyle={{ color: '#52c41a' }} />
//               </Card>
//             </Col>
//             <Col xs={24} sm={12} lg={6}>
//               <Card bordered={false} style={{ borderLeft: '4px solid #faad14', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
//                 <Statistic title="30 derniers jours" value={purchaseStats.last30Days} prefix={<RiseOutlined style={{ color: '#faad14' }} />} valueStyle={{ color: '#faad14' }} />
//               </Card>
//             </Col>
//             <Col xs={24} sm={12} lg={6}>
//               <Card bordered={false} style={{ borderLeft: '4px solid #eb2f96', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
//                 <Statistic title="Paiements réussis" value={purchaseStats.byStatus['succeeded'] || 0} prefix={<CheckCircleOutlined style={{ color: '#eb2f96' }} />} valueStyle={{ color: '#eb2f96' }} />
//               </Card>
//             </Col>
//           </Row>
//         )}
//         <Card bordered={false} style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
//           <Table columns={purchasesColumns} dataSource={purchases} rowKey="id" loading={loading} scroll={{ x: 1400 }} pagination={{ pageSize: 20 }} />
//         </Card>
//       </div>
//     );
//   };

//   const renderInstructorsContent = () => {
//     return (
//       <div>
//         {userStats && (
//           <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
//             <Col xs={24} md={8}>
//               <Card bordered={false} style={{ borderLeft: '4px solid #722ed1', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
//                 <Statistic title="Total Instructeurs" value={userStats.totalInstructors} prefix={<TeamOutlined style={{ color: '#722ed1' }} />} valueStyle={{ color: '#722ed1', fontSize: '28px' }} />
//               </Card>
//             </Col>
//             <Col xs={24} md={8}>
//               <Card bordered={false} style={{ borderLeft: '4px solid #52c41a', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
//                 <Statistic title="Actifs" value={instructors.filter(i => i.isActivated).length} prefix={<UserAddOutlined style={{ color: '#52c41a' }} />} valueStyle={{ color: '#52c41a', fontSize: '28px' }} />
//               </Card>
//             </Col>
//             <Col xs={24} md={8}>
//               <Card bordered={false} style={{ borderLeft: '4px solid #1890ff', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
//                 <Statistic title="Total Cours Créés" value={instructors.reduce((sum, i) => sum + (i.coursesCount || 0), 0)} prefix={<BookOutlined style={{ color: '#1890ff' }} />} valueStyle={{ color: '#1890ff', fontSize: '28px' }} />
//               </Card>
//             </Col>
//           </Row>
//         )}
//         <Card bordered={false} style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
//           <Table columns={usersColumns} dataSource={instructors} rowKey="id" loading={loading} scroll={{ x: 1200 }} pagination={{ pageSize: 20 }} />
//         </Card>
//       </div>
//     );
//   };

//   const renderStudentsContent = () => {
//     return (
//       <div>
//         {userStats && (
//           <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
//             <Col xs={24} md={8}>
//               <Card bordered={false} style={{ borderLeft: '4px solid #13c2c2', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
//                 <Statistic title="Total Étudiants" value={userStats.totalStudents} prefix={<UserOutlined style={{ color: '#13c2c2' }} />} valueStyle={{ color: '#13c2c2', fontSize: '28px' }} />
//               </Card>
//             </Col>
//             <Col xs={24} md={8}>
//               <Card bordered={false} style={{ borderLeft: '4px solid #52c41a', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
//                 <Statistic title="Actifs" value={students.filter(s => s.isActivated).length} prefix={<CheckCircleOutlined style={{ color: '#52c41a' }} />} valueStyle={{ color: '#52c41a', fontSize: '28px' }} />
//               </Card>
//             </Col>
//             <Col xs={24} md={8}>
//               <Card bordered={false} style={{ borderLeft: '4px solid #faad14', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
//                 <Statistic title="Total Cours Achetés" value={students.reduce((sum, s) => sum + (s.purchasesCount || 0), 0)} prefix={<TrophyOutlined style={{ color: '#faad14' }} />} valueStyle={{ color: '#faad14', fontSize: '28px' }} />
//               </Card>
//             </Col>
//           </Row>
//         )}
//         <Card bordered={false} style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
//           <Table columns={usersColumns} dataSource={students} rowKey="id" loading={loading} scroll={{ x: 1200 }} pagination={{ pageSize: 20 }} />
//         </Card>
//       </div>
//     );
//   };

//   const renderPlanPurchasesContent = () => {
//     return (
//       <div>
//         {planPurchaseStats && (<Row gutter={[16, 16]} style={{ marginBottom: 24 }}></Row>)}
//         <Card bordered={false} style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
//           <Table columns={planPurchasesColumns} dataSource={planPurchases} rowKey="id" loading={loading} scroll={{ x: 1400 }} pagination={{ pageSize: 20 }} />
//         </Card>
//       </div>
//     );
//   };

//   const renderCourseDetails = () => {
//     if (!selectedCourse) {
//       return <Card><p style={{ textAlign: "center", color: "#999" }}>Sélectionnez un cours dans le tableau pour voir ses détails</p></Card>;
//     }
//     return (
//       <Card title={
//         <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//           <span>Détails du cours: {selectedCourse.title}</span>
//           {!selectedCourse.approved && (
//             <Space>
//               <Button type="primary" icon={<CheckCircleOutlined />} onClick={() => handleApproveClick(selectedCourse)}>Approuver ce cours</Button>
//               <Button danger icon={<CloseCircleOutlined />} onClick={() => handleReject(selectedCourse.id)}>Rejeter</Button>
//             </Space>
//           )}
//         </div>
//       } loading={loading}>
//         <Row gutter={[24, 24]}>
//           <Col xs={24} md={8}>
//             <Image src={selectedCourse.image} alt={selectedCourse.title} style={{ width: "100%", borderRadius: 8 }} placeholder={<div style={{ height: 200, background: "#f0f0f0" }} />} />
//           </Col>
//           <Col xs={24} md={16}>
//             <Descriptions bordered column={2}>
//               <Descriptions.Item label="ID" span={1}>{selectedCourse.id}</Descriptions.Item>
//               <Descriptions.Item label="Statut" span={1}><Tag color={selectedCourse.approved ? "green" : "orange"}>{selectedCourse.approved ? "Approuvé" : "En attente"}</Tag></Descriptions.Item>
//               <Descriptions.Item label="Prix actuel" span={1}>{selectedCourse.latest_price?.toFixed(2)} $</Descriptions.Item>
//               <Descriptions.Item label="Prix régulier" span={1}>{selectedCourse.before_price?.toFixed(2)} $</Descriptions.Item>
//               <Descriptions.Item label="Nombre de leçons" span={1}>{selectedCourse.lessons}</Descriptions.Item>
//               <Descriptions.Item label="Durée totale" span={1}>{selectedCourse.duration}</Descriptions.Item>
//               <Descriptions.Item label="Durée d'accès" span={1}>{selectedCourse.access_time}</Descriptions.Item>
//               <Descriptions.Item label="Catégorie" span={1}>{selectedCourse.categoryLibelle || selectedCourse.category?.libelle || "Non définie"}</Descriptions.Item>
//               <Descriptions.Item label="Sous-catégorie" span={2}>{selectedCourse.subcategoryLibelle || selectedCourse.subcategory?.libelle || "Non définie"}</Descriptions.Item>
//               <Descriptions.Item label="Description courte" span={2}>{selectedCourse.short_desc || "Aucune description"}</Descriptions.Item>
//               {selectedCourse.overview && (<Descriptions.Item label="Aperçu" span={2}><div dangerouslySetInnerHTML={{ __html: selectedCourse.overview }} /></Descriptions.Item>)}
//               {selectedCourse.requirements && (<Descriptions.Item label="Prérequis" span={2}><div dangerouslySetInnerHTML={{ __html: selectedCourse.requirements }} /></Descriptions.Item>)}
//               {selectedCourse.what_you_will_learn && (<Descriptions.Item label="Ce que vous allez apprendre" span={2}><div dangerouslySetInnerHTML={{ __html: selectedCourse.what_you_will_learn }} /></Descriptions.Item>)}
//               {selectedCourse.who_is_this_course_for && (<Descriptions.Item label="Public cible" span={2}><div dangerouslySetInnerHTML={{ __html: selectedCourse.who_is_this_course_for }} /></Descriptions.Item>)}
//             </Descriptions>
//           </Col>
//         </Row>
//       </Card>
//     );
//   };

//   const renderCoursesContent = () => {
//     const dataSource = selectedMenu === "courses" ? courses : pendingCourses;
//     const approvedCount = courses.filter(c => c.approved).length;
//     const pendingCount = pendingCourses.length;
//     const totalCount = courses.length;
//     return (
//       <Tabs activeKey={activeTab} onChange={setActiveTab}>
//         <TabPane tab={<Badge count={totalCount} color="#1890ff" offset={[10, 0]}><span style={{ paddingRight: 20 }}><BookOutlined style={{ marginRight: 8 }} />Liste des cours</span></Badge>} key="1">
//           <Card bordered={false} style={{ boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }} title={
//             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//               <div><BookOutlined style={{ marginRight: 8, color: '#1890ff' }} />Gestion des Cours</div>
//               <div style={{ display: 'flex', gap: 8 }}>
//                 <Tag color="success" style={{ margin: 0 }}>{approvedCount} Approuvés</Tag>
//                 <Tag color="warning" style={{ margin: 0 }}>{pendingCount} En attente</Tag>
//                 <Tag color="blue" style={{ margin: 0 }}>{totalCount} Total</Tag>
//               </div>
//             </div>
//           }>
//             <Table columns={coursesColumns} dataSource={dataSource} rowKey="id" loading={loading} scroll={{ x: 1400 }}
//               pagination={{ pageSize: 10, showSizeChanger: true, showQuickJumper: true, showTotal: (total, range) => `${range[0]}-${range[1]} sur ${total} cours` }}
//               rowClassName={(record) => record.approved ? 'approved-row' : 'pending-row'} />
//           </Card>
//         </TabPane>
//         <TabPane tab={<Badge count={selectedCourse ? 1 : 0} color="#52c41a" offset={[10, 0]}><span style={{ paddingRight: 20 }}><EyeOutlined style={{ marginRight: 8 }} />Détails du cours</span></Badge>} key="2">
//           {renderCourseDetails()}
//         </TabPane>
//       </Tabs>
//     );
//   };

//   const renderContent = () => {
//     switch (selectedMenu) {
//       case "dashboard":
//         return (
//           <div>
//             <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
//               <Col xs={24} sm={12} lg={6}>
//                 <Card bordered={false} style={{ borderLeft: '4px solid #1890ff', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
//                   <Statistic title="Total Cours" value={courses.length} prefix={<BookOutlined style={{ color: '#1890ff' }} />} valueStyle={{ color: '#1890ff' }} />
//                 </Card>
//               </Col>
//               <Col xs={24} sm={12} lg={6}>
//                 <Card bordered={false} style={{ borderLeft: '4px solid #faad14', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
//                   <Statistic title="Cours en attente" value={pendingCourses.length} prefix={<CloseCircleOutlined style={{ color: '#faad14' }} />} valueStyle={{ color: '#faad14' }} />
//                 </Card>
//               </Col>
//               <Col xs={24} sm={12} lg={6}>
//                 <Card bordered={false} style={{ borderLeft: '4px solid #52c41a', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
//                   <Statistic title="Cours approuvés" value={courses.filter((c) => c.approved).length} prefix={<CheckCircleOutlined style={{ color: '#52c41a' }} />} valueStyle={{ color: '#52c41a' }} />
//                 </Card>
//               </Col>
//               <Col xs={24} sm={12} lg={6}>
//                 <Card bordered={false} style={{ borderLeft: '4px solid #eb2f96', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
//                   <Statistic title="Total Utilisateurs" value={(userStats?.totalInstructors || 0) + (userStats?.totalStudents || 0)} prefix={<UserOutlined style={{ color: '#eb2f96' }} />} valueStyle={{ color: '#eb2f96' }} />
//                 </Card>
//               </Col>
//             </Row>
//           </div>
//         );

//       case "courses":
//         return (<div><h2 style={{ marginBottom: 24 }}>Tous les Cours</h2>{renderCoursesContent()}</div>);

//       case "pending-courses":
//         return (<div><h2 style={{ marginBottom: 24 }}>Cours en attente d'approbation</h2>{renderCoursesContent()}</div>);

//       case "purchases":
//         return (<div><h2 style={{ marginBottom: 24 }}>Gestion des Paiements</h2>{renderPurchasesContent()}</div>);

//       case "instructors":
//         return (<div><h2 style={{ marginBottom: 24 }}>Gestion des Instructeurs</h2>{renderInstructorsContent()}</div>);

//       case "students":
//         return (<div><h2 style={{ marginBottom: 24 }}>Gestion des Étudiants</h2>{renderStudentsContent()}</div>);

//       case "user-management":
//         return (<div><h2 style={{ marginBottom: 24 }}>Gestion des Utilisateurs</h2><UserManagement /></div>);

//       case "plan-purchases":
//         return (<div><h2 style={{ marginBottom: 24 }}>Gestion des Achats de Plans</h2>{renderPlanPurchasesContent()}</div>);

//       case "live-trainings":
//         return (<div><h2 style={{ marginBottom: 24 }}>🔴 Gestion des Formations Live</h2><LiveTrainingsAdmin /></div>);

//       default:
//         return <h2>Welcome to Admin Dashboard</h2>;
//     }
//   };

//   return (
//     <Layout style={{ minHeight: "100vh" }}>
//       <Sider
//         breakpoint="lg"
//         collapsedWidth="0"
//         style={{
//           boxShadow: '2px 0 8px rgba(0,0,0,0.15)',
//           // ✅ Couleur de fond Nomidya (bleu) — aligné avec le logo et le header
//           background: 'linear-gradient(180deg, #0054A6 0%, #003B75 100%)',
//         }}
//       >
//         <div
//           style={{
//             height: 64,
//             margin: 16,
//             // ✅ Logo container avec accent orange Nomidya
//             background: 'linear-gradient(135deg, rgba(232, 134, 12, 0.25) 0%, rgba(255, 255, 255, 0.15) 100%)',
//             border: '1px solid rgba(232, 134, 12, 0.3)',
//             borderRadius: 10,
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             color: 'white',
//             fontSize: '18px',
//             fontWeight: 'bold',
//             letterSpacing: '0.5px',
//             textShadow: '0 1px 2px rgba(0,0,0,0.2)'
//           }}
//         >
//           NOMIDYA ADMIN
//         </div>

//         {/* ✅ Styles personnalisés pour le menu (bleu Nomidya + accent orange) */}
//         <style>{`
//           .nomidya-admin-menu.ant-menu-dark,
//           .nomidya-admin-menu.ant-menu-dark .ant-menu-sub {
//             background: transparent !important;
//           }
//           .nomidya-admin-menu.ant-menu-dark .ant-menu-item {
//             color: rgba(255, 255, 255, 0.85) !important;
//             border-radius: 6px !important;
//             margin: 4px 8px !important;
//             width: calc(100% - 16px) !important;
//             transition: all 0.2s ease !important;
//           }
//           .nomidya-admin-menu.ant-menu-dark .ant-menu-item:hover {
//             background: rgba(232, 134, 12, 0.2) !important;
//             color: #fff !important;
//           }
//           .nomidya-admin-menu.ant-menu-dark .ant-menu-item-selected {
//             background: linear-gradient(135deg, #E8860C 0%, #d97706 100%) !important;
//             color: #fff !important;
//             font-weight: 600 !important;
//             box-shadow: 0 4px 12px rgba(232, 134, 12, 0.4) !important;
//           }
//           .nomidya-admin-menu.ant-menu-dark .ant-menu-item-selected::after {
//             display: none !important;
//           }
//           .nomidya-admin-menu.ant-menu-dark .ant-menu-item .anticon {
//             font-size: 16px !important;
//           }
//         `}</style>

//         <Menu
//           theme="dark"
//           mode="inline"
//           defaultSelectedKeys={["dashboard"]}
//           onClick={(e) => setSelectedMenu(e.key)}
//           style={{ borderRight: 0, marginTop: 8 }}
//           className="nomidya-admin-menu"
//         >
//           <Menu.Item key="dashboard" icon={<DashboardOutlined />}>Dashboard</Menu.Item>
//           <Menu.Item key="courses" icon={<BookOutlined />}>Tous les Cours</Menu.Item>
//           <Menu.Item key="pending-courses" icon={<BookOutlined />}>Cours en attente</Menu.Item>
//           <Menu.Item key="purchases" icon={<DollarOutlined />}>Paiements</Menu.Item>
//           <Menu.Item key="instructors" icon={<TeamOutlined />}>Instructeurs</Menu.Item>
//           <Menu.Item key="students" icon={<UserOutlined />}>Étudiants</Menu.Item>
//           <Menu.Item key="user-management" icon={<TeamOutlined />}>Gestion Utilisateurs</Menu.Item>
//           <Menu.Item key="plan-purchases" icon={<TrophyOutlined />}>Achats de Plans</Menu.Item>
//           <Menu.Item key="live-trainings" icon={<VideoCameraOutlined />}>🔴 Formations Live</Menu.Item>

//           {/* ✅ Certificats → ouvre une modal (comme ModeratorCourses) */}
//           <Menu.Item key="manual-certificates" icon={<SafetyCertificateOutlined />}>
//             Certificats
//           </Menu.Item>
//         </Menu>
//       </Sider>

//       <Layout>
//         <Header style={{ padding: '0 24px', background: '#fff', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
//           <Button type="primary" icon={<SettingOutlined />} onClick={() => setIsManagementModalVisible(true)} style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', border: 'none', height: '40px', borderRadius: '8px', fontWeight: 'bold' }}>
//             Gestion Générale
//           </Button>
//         </Header>

//         <Content style={{ margin: "24px 16px", padding: 24, background: '#f0f2f5' }}>
//           {renderContent()}
//         </Content>

//         <Footer style={{ textAlign: "center", background: '#fff' }}>©2024 Nomidya. Tous droits réservés.</Footer>

//         <CourseEditModal visible={editModalVisible} courseId={editingCourseId}
//           onClose={() => { setEditModalVisible(false); setEditingCourseId(null); }}
//           onSuccess={() => {
//             if (selectedMenu === "courses") loadAllCourses();
//             else if (selectedMenu === "pending-courses") loadPendingCourses();
//           }} />
//       </Layout>

//       {/* ====== MODAL CERTIFICATS — EXACTEMENT comme dans ModeratorCourses ====== */}
//       {/*    width="98%", style top:10, body padding 20, Tabs intérieures size="small"     */}
//       {/*    ✅ Pas de sélecteur de cours : le composant CertificateGenerator charge      */}
//       {/*       automatiquement le dernier template depuis la BDD via useEffect           */}
//       <Modal
//         open={isCertificatesModalVisible}
//         title={
//           <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
//             <SafetyCertificateOutlined style={{ fontSize: '20px' }} />
//             <span>Gestion des certificats</span>
//           </div>
//         }
//         footer={null}
//         width="98%"
//         style={{ top: 10 }}
//         bodyStyle={{
//           height: 'calc(100vh - 120px)',
//           overflowY: 'auto',
//           padding: '20px'
//         }}
//         onCancel={() => {
//           setIsCertificatesModalVisible(false);
//         }}
//         destroyOnClose
//         maskClosable={false}
//       >
//         <div style={{ position: "relative" }}>
//           {/* ✅ EXACTEMENT le même pattern Tabs que ModeratorCourses */}
//           {/*    Le composant CertificateGenerator se débrouille avec son useEffect */}
//           {/*    pour charger le dernier template existant en BDD */}
//           <Tabs defaultActiveKey="template" type="card" size="small">
//             <TabPane tab={<span><SettingOutlined /> Modèle du certificat</span>} key="template">
//               <CertificateGenerator
//                 studentName="Nom"
//                 courseTitle="Cours"
//                 courseId={courses[0]?.id}
//               />
//             </TabPane>

//             <TabPane tab={<span><ContactsOutlined /> Génération manuelle</span>} key="manual">
//               <ManualCertificateGenerator />
//             </TabPane>
//           </Tabs>
//         </div>
//       </Modal>

//       <Modal title={`Approuver le cours: ${selectedCourse?.title}`} visible={modalVisible} onOk={handleApprove} onCancel={() => setModalVisible(false)} okText="Approuver" cancelText="Annuler" width={600}>
//         <Form form={form} layout="vertical">
//           <Form.Item label="Prix actuel ($)" name="latestPrice" rules={[{ required: true, message: "Veuillez entrer le prix actuel" }]}>
//             <InputNumber min={0} step={0.01} style={{ width: "100%" }} />
//           </Form.Item>
//           <Form.Item label="Prix régulier ($)" name="beforePrice" rules={[{ required: true, message: "Veuillez entrer le prix régulier" }]}>
//             <InputNumber min={0} step={0.01} style={{ width: "100%" }} />
//           </Form.Item>
//           <Form.Item label="Durée d'accès" name="accessTime" rules={[{ required: true, message: "Veuillez sélectionner la durée" }]}>
//             <Select>
//               <Option value="À vie">À vie</Option>
//               <Option value="3 mois">3 mois</Option>
//               <Option value="6 mois">6 mois</Option>
//               <Option value="1 an">1 an</Option>
//             </Select>
//           </Form.Item>
//         </Form>
//       </Modal>

//       <Modal open={isManagementModalVisible} title={
//         <div style={{ fontSize: '20px', fontWeight: 'bold', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
//           Gestion Générale
//         </div>
//       } footer={null} width="90%" onCancel={() => setIsManagementModalVisible(false)} style={{ top: 20 }} destroyOnClose maskClosable={false}>
//         <Tabs defaultActiveKey="1" tabPosition="top" type="line">
//           <TabPane tab={<span style={{ fontSize: '15px' }}><SettingOutlined style={{ color: "#13c2c2", fontSize: '18px' }} /> Gestion des Plans</span>} key="1"><PlanManager /></TabPane>
//           <TabPane tab={<span style={{ fontSize: '15px' }}><FileImageOutlined style={{ color: "#eb2f96", fontSize: '18px' }} /> Actualités</span>} key="2"><NewsManager /></TabPane>
//           <TabPane tab={<span style={{ fontSize: '15px' }}><ContactsOutlined style={{ color: "#1890ff", fontSize: '18px' }} /> Demandes de Contact</span>} key="3"><SalesRequestManager /></TabPane>
//           <TabPane tab={<span style={{ fontSize: '15px' }}><TeamOutlined style={{ color: "#722ed1", fontSize: '18px' }} /> Candidatures Instructeur</span>} key="4"><InstructorRequestManager /></TabPane>
//           <TabPane tab={<span style={{ fontSize: '15px' }}><AppstoreOutlined style={{ color: "#fa8c16", fontSize: '18px' }} /> Catégories</span>} key="5"><CategoryManager /></TabPane>
//         </Tabs>
//       </Modal>
//     </Layout>
//   );
// };

// export default BoardAdmin;


import React, { useState, useEffect } from "react";
import {
  Layout, Menu, Table, Card, Descriptions, Modal, Form, InputNumber,
  Select, Tag, message, Button, Tabs, Row, Col, Image, Statistic, Space,
  Badge
} from "antd";
import {
  DashboardOutlined,
  UserOutlined,
  TeamOutlined,
  BookOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  EyeOutlined,
  DollarOutlined,
  SettingOutlined,
  FileImageOutlined,
  ContactsOutlined,
  RiseOutlined,
  FallOutlined,
  ShoppingCartOutlined,
  UserAddOutlined,
  TrophyOutlined, AppstoreOutlined
  , MailOutlined, DeleteOutlined, CopyOutlined, ClockCircleOutlined, EditOutlined
  , VideoCameraOutlined,
  EyeInvisibleOutlined,
  SafetyCertificateOutlined,
  UnorderedListOutlined
} from "@ant-design/icons";
import courseService from "../../services/course.service";
import PlanManager from "../moderateur/PlanManager";
import NewsManager from "../moderateur/NewsManager";
import SalesRequestManager from "../moderateur/SalesRequestManager";
import InstructorRequestManager from "../moderateur/InstructorRequestManager";
import CategoryManager from "../moderateur/CategoryManager";
import UserManagement from "../admin/UserManagement";
import CourseEditModal from "./CourseEditModal";
import LiveTrainingsAdmin from "./live-trainings/LiveTrainingsAdmin";
// ✅ Imports des composants Certificats (exactement comme ModeratorCourses)
import ManualCertificateGenerator from "../moderateur/ManualCertificateGenerator";
import CertificateGenerator from "../moderateur/CertificateGenerator";
// ✅ NOUVEAU : Composant de gestion des certificats envoyés (admin)
import SentCertificatesManager from "./SentCertificatesManager";


const { Header, Content, Footer, Sider } = Layout;
const { Option } = Select;
const { TabPane } = Tabs;

const BoardAdmin = () => {
  const [selectedMenu, setSelectedMenu] = useState("dashboard");
  const [courses, setCourses] = useState([]);
  const [pendingCourses, setPendingCourses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [activeTab, setActiveTab] = useState("1");
  const [form] = Form.useForm();
  const [isManagementModalVisible, setIsManagementModalVisible] = useState(false);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [editingCourseId, setEditingCourseId] = useState(null);
  const [purchases, setPurchases] = useState([]);
  const [purchaseStats, setPurchaseStats] = useState(null);
  const [instructors, setInstructors] = useState([]);
  const [students, setStudents] = useState([]);
  const [userStats, setUserStats] = useState(null);

  const [planPurchases, setPlanPurchases] = useState([]);
  const [planPurchaseStats, setPlanPurchaseStats] = useState(null);

  // ✅ NOUVEAU : Modal Certificats (reproduit exactement le pattern ModeratorCourses)
  //    Pas besoin de sélecteur de cours : CertificateGenerator charge automatiquement
  //    le dernier template existant en BDD via son useEffect interne
  const [isCertificatesModalVisible, setIsCertificatesModalVisible] = useState(false);

  useEffect(() => {
    if (selectedMenu === "courses") {
      loadAllCourses();
    } else if (selectedMenu === "pending-courses") {
      loadPendingCourses();
    } else if (selectedMenu === "purchases") {
      loadPurchases();
    } else if (selectedMenu === "instructors") {
      loadInstructors();
    } else if (selectedMenu === "students") {
      loadStudents();
    } else if (selectedMenu === "plan-purchases") {
      loadPlanPurchases();
    } else if (selectedMenu === "manual-certificates") {
      // ✅ Charger les cours + ouvrir la modal
      loadAllCourses();
      setIsCertificatesModalVisible(true);
      // Reset au menu précédent pour pouvoir rouvrir la modal
      setTimeout(() => setSelectedMenu("dashboard"), 100);
    }
  }, [selectedMenu]);

  const planPurchasesColumns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: 60,
    },
    {
      title: "Date d'achat",
      dataIndex: "purchasedAt",
      key: "purchasedAt",
      width: 150,
      render: (date) => new Date(date).toLocaleDateString('fr-FR'),
      sorter: (a, b) => new Date(a.purchasedAt) - new Date(b.purchasedAt),
    },
    {
      title: "Utilisateur",
      dataIndex: "username",
      key: "username",
      render: (text, record) => (
        <div>
          <div style={{ fontWeight: 'bold' }}>{text}</div>
          <div style={{ fontSize: '12px', color: '#999' }}>{record.userEmail}</div>
        </div>
      ),
    },
    {
      title: "Plan",
      dataIndex: "planTitle",
      key: "planTitle",
      ellipsis: true,
    },
    {
      title: "Montant",
      dataIndex: "amountInDollars",
      key: "amount",
      width: 120,
      render: (amount, record) => (
        <span style={{ fontWeight: 'bold', color: '#52c41a' }}>
          {amount.toFixed(2)} {record.currency}
        </span>
      ),
    },
    {
      title: "Période",
      dataIndex: "period",
      key: "period",
      width: 120,
      render: (period) => (
        <Tag color={period === 'ANNUAL' ? 'blue' : 'purple'}>
          {period === 'ANNUAL' ? 'Annuel' : 'Trimestriel'}
        </Tag>
      ),
    },
    {
      title: "Statut",
      dataIndex: "status",
      key: "status",
      width: 100,
      render: (status) => (
        <Tag color={status === 'APPROVED' ? 'green' : 'red'}>
          {status}
        </Tag>
      ),
    },
    {
      title: "Activation",
      dataIndex: "isActive",
      key: "isActive",
      width: 100,
      render: (isActive) => (
        <Tag color={isActive ? 'success' : 'default'}>
          {isActive ? 'Actif' : 'Inactif'}
        </Tag>
      ),
    },
    {
      title: "Jours restants",
      dataIndex: "expiresAt",
      key: "daysRemaining",
      width: 120,
      render: (expiresAt, record) => {
        if (!expiresAt || !record.isActive) {
          return <span style={{ color: '#999' }}>N/A</span>;
        }

        const now = new Date();
        const expiry = new Date(expiresAt);
        const daysLeft = Math.ceil((expiry - now) / (1000 * 60 * 60 * 24));

        let color = 'green';
        if (daysLeft <= 5) color = 'red';
        else if (daysLeft <= 15) color = 'orange';

        return (
          <Tag color={color} style={{ fontWeight: 'bold' }}>
            {daysLeft > 0 ? `${daysLeft} jours` : 'Expiré'}
          </Tag>
        );
      },
      sorter: (a, b) => {
        if (!a.expiresAt) return 1;
        if (!b.expiresAt) return -1;
        return new Date(a.expiresAt) - new Date(b.expiresAt);
      },
    },
    {
      title: "Expire le",
      dataIndex: "expiresAt",
      key: "expiresAt",
      width: 120,
      render: (date) => date ? new Date(date).toLocaleDateString('fr-FR') : 'N/A',
    },
    {
      title: "Email envoyé",
      dataIndex: "accessEmailSent",
      key: "accessEmailSent",
      width: 100,
      render: (sent) => (
        <Tag color={sent ? 'green' : 'orange'}>
          {sent ? 'Oui' : 'Non'}
        </Tag>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      width: 280,
      fixed: 'right',
      render: (_, record) => (
        <Space direction="vertical" size="small">
          <Space>
            {!record.isActive && record.status === 'APPROVED' && (
              <Button
                type="primary"
                size="small"
                icon={<CheckCircleOutlined />}
                onClick={() => handleActivatePlan(record.id)}
                style={{ background: '#52c41a', borderColor: '#52c41a' }}
              >
                Activer
              </Button>
            )}

            {record.isActive && (
              <Button
                danger
                size="small"
                icon={<CloseCircleOutlined />}
                onClick={() => handleDeactivatePlan(record.id)}
              >
                Désactiver
              </Button>
            )}

            <Button
              type="default"
              size="small"
              icon={<MailOutlined />}
              onClick={() => handleResendEmail(record.id)}
              disabled={!record.isActive}
            >
              Email
            </Button>
          </Space>
        </Space>
      ),
    },
  ];

  const handleDeleteCourse = async (courseId, courseTitle) => {
    const showDeletionChoiceModal = () => {
      Modal.confirm({
        title: `Supprimer le cours : ${courseTitle}`,
        content: (
          <div style={{ padding: '16px 0' }}>
            <p style={{ marginBottom: 16, fontSize: '14px' }}>
              Choisissez le type de suppression pour ce cours :
            </p>

            <div style={{ marginBottom: 12 }}>
              <div style={{
                padding: '12px',
                border: '2px solid #1890ff',
                borderRadius: '8px',
                backgroundColor: '#f0f7ff',
                marginBottom: '12px'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
                  <span style={{ fontSize: '16px', marginRight: 8 }}>🔒</span>
                  <strong style={{ color: '#1890ff' }}>Désactiver (Recommandé)</strong>
                </div>
                <small style={{ color: '#666', lineHeight: 1.4 }}>
                  Le cours sera masqué mais restera dans la base de données.
                  Il pourra être restauré plus tard si nécessaire.
                </small>
              </div>

              <div style={{
                padding: '12px',
                border: '2px solid #ff4d4f',
                borderRadius: '8px',
                backgroundColor: '#fff2f0'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
                  <span style={{ fontSize: '16px', marginRight: 8 }}>🗑️</span>
                  <strong style={{ color: '#ff4d4f' }}>Supprimer définitivement</strong>
                </div>
                <small style={{ color: '#ff4d4f', lineHeight: 1.4 }}>
                  Le cours et toutes ses données seront supprimés de la base de données.
                  Cette action est irréversible !
                </small>
              </div>
            </div>
          </div>
        ),
        icon: null,
        okText: "Supprimer définitivement",
        okType: "danger",
        cancelText: "Désactiver",
        width: 520,

        onOk: async () => {
          return new Promise((resolve, reject) => {
            Modal.confirm({
              title: "Confirmation suppression définitive",
              content: (
                <div>
                  <p style={{ marginBottom: 8 }}>
                    Confirmez-vous la suppression définitive du cours <strong>"{courseTitle}"</strong> ?
                  </p>
                  <p style={{ color: '#ff4d4f', fontSize: '12px', fontWeight: 'bold' }}>
                    Le processus se déroulera en 2 étapes automatiques :
                  </p>
                  <ol style={{ color: '#666', fontSize: '12px', marginLeft: 16 }}>
                    <li>Désactivation logique du cours</li>
                    <li>Suppression physique définitive</li>
                  </ol>
                </div>
              ),
              icon: <DeleteOutlined style={{ color: '#ff4d4f' }} />,
              okText: "Oui, supprimer définitivement",
              okType: "danger",
              cancelText: "Annuler",
              onOk: async () => {
                try {
                  setLoading(true);
                  message.loading("Étape 1/2 : Désactivation du cours...", 0);
                  const softDeleteResponse = await courseService.softDeleteCourse(courseId);
                  await new Promise(resolve => setTimeout(resolve, 1000));
                  message.loading("Étape 2/2 : Suppression définitive...", 0);
                  const permanentDeleteResponse = await courseService.permanentlyDeleteCourse(courseId);
                  message.destroy();
                  message.success("Cours supprimé définitivement avec succès");

                  if (selectedMenu === "courses") {
                    loadAllCourses();
                  } else if (selectedMenu === "pending-courses") {
                    loadPendingCourses();
                  }
                  resolve();

                } catch (error) {
                  message.destroy();
                  if (error.response) {
                    if (error.response.status === 400) {
                      message.error(`Erreur backend : ${error.response.data}`);
                    } else if (error.response.status === 403) {
                      message.error("Accès refusé : permissions insuffisantes");
                    } else {
                      message.error(`Erreur HTTP ${error.response.status}: ${error.response.data}`);
                    }
                  } else if (error.request) {
                    message.error("Erreur réseau : impossible de contacter le serveur");
                  } else {
                    message.error(`Erreur : ${error.message}`);
                  }
                  reject(error);
                } finally {
                  setLoading(false);
                }
              },
              onCancel: () => resolve()
            });
          });
        },

        onCancel: async () => {
          Modal.confirm({
            title: "Confirmer la désactivation",
            content: (
              <div>
                <p>
                  Le cours <strong>"{courseTitle}"</strong> sera désactivé et masqué aux utilisateurs.
                </p>
                <p style={{ color: '#1890ff', fontSize: '12px', marginTop: 8 }}>
                  Vous pourrez le restaurer plus tard depuis la section "Cours supprimés".
                </p>
              </div>
            ),
            icon: <EyeOutlined style={{ color: '#1890ff' }} />,
            okText: "Désactiver",
            okType: "primary",
            cancelText: "Annuler",
            onOk: async () => {
              try {
                setLoading(true);
                const response = await courseService.softDeleteCourse(courseId);
                message.success("Cours désactivé avec succès");
                if (selectedMenu === "courses") {
                  loadAllCourses();
                } else if (selectedMenu === "pending-courses") {
                  loadPendingCourses();
                }
              } catch (error) {
                message.error("Erreur lors de la désactivation");
              } finally {
                setLoading(false);
              }
            }
          });
        }
      });
    };

    showDeletionChoiceModal();
  };

  const loadPlanPurchases = async () => {
    setLoading(true);
    try {
      const data = await courseService.getAllPlanPurchases();
      setPlanPurchases(data);
      const stats = await courseService.getPlanPurchaseStats();
      setPlanPurchaseStats(stats);
    } catch (error) {
      message.error("Erreur lors du chargement des achats de plans");
    } finally {
      setLoading(false);
    }
  };

  const loadAllCourses = async () => {
    setLoading(true);
    try {
      const data = await courseService.getAllCoursesForAdmin();
      setCourses(data);
    } catch (error) {
      message.error("Erreur lors du chargement des cours");
    } finally {
      setLoading(false);
    }
  };

  const loadPendingCourses = async () => {
    setLoading(true);
    try {
      const data = await courseService.getPendingCourses();
      setPendingCourses(data);
    } catch (error) {
      message.error("Erreur lors du chargement des cours en attente");
    } finally {
      setLoading(false);
    }
  };

  const handleActivatePlan = async (purchaseId) => {
    Modal.confirm({
      title: "Activer ce plan ?",
      content: "Le compteur de durée sera lancé et un email d'accès sera envoyé à l'utilisateur.",
      okText: "Activer",
      cancelText: "Annuler",
      onOk: async () => {
        try {
          setLoading(true);
          const response = await courseService.activatePlanPurchase(purchaseId);
          if (response.success) {
            message.success(response.message);
          } else {
            message.warning("Plan activé mais vérifiez la configuration email");
          }
          await loadPlanPurchases();
        } catch (error) {
          message.error("Erreur lors de l'activation du plan");
        } finally {
          setLoading(false);
        }
      },
    });
  };

  const handleDeactivatePlan = async (purchaseId) => {
    Modal.confirm({
      title: "Désactiver ce plan ?",
      content: "L'utilisateur perdra l'accès au plan.",
      okText: "Désactiver",
      okType: "danger",
      cancelText: "Annuler",
      onOk: async () => {
        try {
          setLoading(true);
          await courseService.deactivatePlanPurchase(purchaseId);
          message.success("Plan désactivé avec succès");
          loadPlanPurchases();
        } catch (error) {
          message.error("Erreur lors de la désactivation du plan");
        } finally {
          setLoading(false);
        }
      },
    });
  };

  const handleResendEmail = async (purchaseId) => {
    try {
      setLoading(true);
      await courseService.resendPlanAccessEmail(purchaseId);
      message.success("Email d'accès renvoyé avec succès");
      loadPlanPurchases();
    } catch (error) {
      message.error("Erreur lors de l'envoi de l'email");
    } finally {
      setLoading(false);
    }
  };

  const loadPurchases = async () => {
    setLoading(true);
    try {
      const data = await courseService.getAllPurchases();
      setPurchases(data);
      const stats = await courseService.getPurchaseStats();
      setPurchaseStats(stats);
    } catch (error) {
      message.error("Erreur lors du chargement des paiements");
    } finally {
      setLoading(false);
    }
  };

  const loadInstructors = async () => {
    setLoading(true);
    try {
      const data = await courseService.getAllInstructors();
      setInstructors(data);
      const stats = await courseService.getUserStats();
      setUserStats(stats);
    } catch (error) {
      message.error("Erreur lors du chargement des instructeurs");
    } finally {
      setLoading(false);
    }
  };

  const loadStudents = async () => {
    setLoading(true);
    try {
      const data = await courseService.getAllStudents();
      setStudents(data);
      const stats = await courseService.getUserStats();
      setUserStats(stats);
    } catch (error) {
      message.error("Erreur lors du chargement des étudiants");
    } finally {
      setLoading(false);
    }
  };

  const handleToggleActivation = async (userId) => {
    try {
      await courseService.toggleUserActivation(userId);
      message.success("Statut mis à jour avec succès");
      if (selectedMenu === "instructors") loadInstructors();
      if (selectedMenu === "students") loadStudents();
    } catch (error) {
      message.error("Erreur lors de la mise à jour du statut");
    }
  };

  const handleDeleteUser = (userId) => {
    Modal.confirm({
      title: "Êtes-vous sûr de vouloir supprimer cet utilisateur ?",
      content: "Cette action est irréversible",
      onOk: async () => {
        try {
          await courseService.deleteUser(userId);
          message.success("Utilisateur supprimé avec succès");
          if (selectedMenu === "instructors") loadInstructors();
          if (selectedMenu === "students") loadStudents();
        } catch (error) {
          message.error("Erreur lors de la suppression");
        }
      },
    });
  };

  const handleApproveClick = (course) => {
    setSelectedCourse(course);
    form.setFieldsValue({
      latestPrice: course.latest_price || 1,
      beforePrice: course.before_price || 1,
      accessTime: course.access_time || "À vie",
    });
    setModalVisible(true);
  };

  const handleApprove = async () => {
    try {
      const values = await form.validateFields();
      await courseService.approveCourse(
        selectedCourse.id,
        values.latestPrice,
        values.beforePrice,
        values.accessTime
      );
      message.success("Cours approuvé avec succès !");
      setModalVisible(false);
      setSelectedCourse(null);
      loadPendingCourses();
      loadAllCourses();
    } catch (error) {
      message.error("Erreur lors de l'approbation du cours");
    }
  };

  const handleReject = async (courseId) => {
    Modal.confirm({
      title: "Êtes-vous sûr de vouloir rejeter ce cours ?",
      onOk: async () => {
        try {
          await courseService.rejectCourse(courseId);
          message.success("Cours rejeté");
          setSelectedCourse(null);
          loadPendingCourses();
          loadAllCourses();
        } catch (error) {
          message.error("Erreur lors du rejet du cours");
        }
      },
    });
  };

  const handleUnapprove = async (course) => {
    Modal.confirm({
      title: `Masquer le cours : ${course.title}`,
      content: (
        <div>
          <p style={{ marginBottom: 12 }}>
            Le cours sera <strong>masqué au public</strong> mais restera disponible :
          </p>
          <ul style={{ marginLeft: 16, color: '#666' }}>
            <li>✅ Le modérateur peut continuer à le modifier</li>
            <li>✅ Le cours reste dans la base de données</li>
            <li>❌ Les étudiants ne pourront plus le voir ni l'acheter</li>
            <li>✅ Vous pourrez le réapprouver à tout moment</li>
          </ul>
        </div>
      ),
      icon: <EyeInvisibleOutlined style={{ color: '#fa8c16' }} />,
      okText: "Masquer le cours",
      okType: "warning",
      cancelText: "Annuler",
      width: 500,
      onOk: async () => {
        try {
          setLoading(true);
          await courseService.unapproveCourse(course.id);
          message.success(`Cours "${course.title}" masqué avec succès`);
          if (selectedMenu === "courses") {
            loadAllCourses();
          } else if (selectedMenu === "pending-courses") {
            loadPendingCourses();
          }
        } catch (error) {
          message.error("Erreur lors du masquage du cours");
        } finally {
          setLoading(false);
        }
      }
    });
  };

  const handleViewDetails = async (course) => {
    if (course.overview || course.requirements) {
      setSelectedCourse(course);
      setActiveTab("2");
      return;
    }

    try {
      setLoading(true);
      const fullCourse = await courseService.getCourseDetails(course.id);
      setSelectedCourse(fullCourse);
      setActiveTab("2");
    } catch (error) {
      message.error("Erreur lors du chargement des détails");
    } finally {
      setLoading(false);
    }
  };

  const usersColumns = [
    { title: "ID", dataIndex: "id", key: "id", width: 60 },
    {
      title: "Utilisateur",
      dataIndex: "username",
      key: "username",
      render: (text, record) => (
        <div>
          <div style={{ fontWeight: 'bold' }}>{text}</div>
          <div style={{ fontSize: '12px', color: '#999' }}>{record.email}</div>
        </div>
      ),
    },
    {
      title: "Type",
      dataIndex: "roles",
      key: "roles",
      render: (roles) => (
        <>
          {roles.map(role => {
            let color = "blue";
            if (role === "Student") color = "green";
            if (role === "Instructor") color = "purple";
            if (role === "Admin") color = "red";
            return <Tag key={role} color={color}>{role}</Tag>;
          })}
        </>
      ),
    },
    { title: "Cours créés", dataIndex: "coursesCount", key: "coursesCount", width: 120, render: (count) => count || 0 },
    { title: "Cours achetés", dataIndex: "purchasesCount", key: "purchasesCount", width: 120, render: (count) => count || 0 },
    {
      title: "Statut",
      key: "status",
      width: 200,
      render: (_, record) => (
        <div>
          <Tag color={record.isActivated ? "green" : "red"}>{record.isActivated ? "Actif" : "Inactif"}</Tag>
          <Tag color={record.isEmailConfirmed ? "green" : "orange"}>{record.isEmailConfirmed ? "Email confirmé" : "Non confirmé"}</Tag>
        </div>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      width: 200,
      fixed: 'right',
      render: (_, record) => (
        <Space>
          <Button type={record.isActivated ? "default" : "primary"} size="small" onClick={() => handleToggleActivation(record.id)}>
            {record.isActivated ? "Désactiver" : "Activer"}
          </Button>
          <Button danger size="small" onClick={() => handleDeleteUser(record.id)}>Supprimer</Button>
        </Space>
      ),
    },
  ];

  const purchasesColumns = [
    { title: "ID", dataIndex: "id", key: "id", width: 60 },
    {
      title: "Date", dataIndex: "purchasedAt", key: "purchasedAt", width: 180,
      render: (date) => new Date(date).toLocaleString('fr-FR'),
      sorter: (a, b) => new Date(a.purchasedAt) - new Date(b.purchasedAt),
    },
    {
      title: "Utilisateur", dataIndex: "username", key: "username", ellipsis: true,
      render: (text, record) => (
        <div><div>{text}</div><div style={{ fontSize: '12px', color: '#999' }}>{record.userEmail}</div></div>
      ),
    },
    { title: "Cours", dataIndex: "courseTitle", key: "courseTitle", ellipsis: true },
    {
      title: "Montant", dataIndex: "amountInDollars", key: "amount", width: 120,
      render: (amount, record) => <span style={{ fontWeight: 'bold' }}>{amount.toFixed(2)} {record.currency}</span>,
    },
    { title: "Méthode", dataIndex: "paymentMethod", key: "paymentMethod", width: 100 },
    {
      title: "Statut", dataIndex: "status", key: "status", width: 120,
      render: (status) => {
        const colors = { 'succeeded': 'green', 'APPROVED': 'green', 'processing': 'blue', 'requires_payment_method': 'orange', 'canceled': 'red' };
        return <Tag color={colors[status] || 'default'}>{status}</Tag>;
      },
    },
    { title: "Référence", dataIndex: "paymentIntentId", key: "paymentIntentId", ellipsis: true, width: 200 },
  ];

  const coursesColumns = [
    {
      title: "ID", dataIndex: "id", key: "id", width: 60, align: 'center',
      render: (id) => <Tag color="blue" style={{ fontWeight: 'bold' }}>#{id}</Tag>
    },
    {
      title: "Cours", dataIndex: "title", key: "title", ellipsis: true,
      render: (title, record) => (
        <div>
          <div style={{ fontWeight: 'bold', marginBottom: 4 }}>{title}</div>
          <div style={{ fontSize: '12px', color: '#999' }}>{record.lessons} leçons • {record.duration}</div>
        </div>
      )
    },
    {
      title: "Prix", key: "pricing", width: 120, align: 'center',
      render: (_, record) => (
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '16px', fontWeight: 'bold', color: '#52c41a' }}>${record.latest_price?.toFixed(2)}</div>
          {record.before_price > record.latest_price && (
            <div style={{ fontSize: '12px', color: '#999', textDecoration: 'line-through' }}>${record.before_price?.toFixed(2)}</div>
          )}
        </div>
      )
    },
    {
      title: "Accès", dataIndex: "access_time", key: "access_time", width: 100, align: 'center',
      render: (access_time) => <Tag icon={<ClockCircleOutlined />} color={access_time === "À vie" ? "green" : "blue"}>{access_time}</Tag>
    },
    {
      title: "Catégorie", dataIndex: "categoryLibelle", key: "category", ellipsis: true,
      render: (category) => <Tag color="purple">{category}</Tag>
    },
    {
      title: "Statut", dataIndex: "approved", key: "approved", width: 120, align: 'center',
      render: (approved) => (
        <Tag icon={approved ? <CheckCircleOutlined /> : <ClockCircleOutlined />} color={approved ? "success" : "warning"} style={{ fontWeight: 'bold' }}>
          {approved ? "Approuvé" : "En attente"}
        </Tag>
      ),
    },
    {
      title: "Actions", key: "actions", width: 400, fixed: 'right',
      render: (_, record) => (
        <Space wrap size={[4, 8]}>
          <Button type="default" size="small" icon={<EyeOutlined />} onClick={() => handleViewDetails(record)} style={{ borderColor: '#1890ff', color: '#1890ff' }}>Détails</Button>
          {!record.approved && (
            <>
              <Button type="primary" size="small" icon={<CheckCircleOutlined />} onClick={() => handleApproveClick(record)} style={{ background: '#52c41a', borderColor: '#52c41a', fontWeight: 'bold' }}>Approuver</Button>
              <Button danger size="small" icon={<CloseCircleOutlined />} onClick={() => handleReject(record.id)} style={{ fontWeight: 'bold' }}>Rejeter</Button>
            </>
          )}
          {record.approved && (
            <>
              <Button type="default" size="small" icon={<EditOutlined />} onClick={() => handleEditCourse(record.id)} style={{ borderColor: '#faad14', color: '#faad14' }}>Modifier</Button>
              <Button type="default" size="small" icon={<EyeInvisibleOutlined />} onClick={() => handleUnapprove(record)} style={{ borderColor: '#fa8c16', color: '#fa8c16', fontWeight: 'bold' }}>Masquer</Button>
            </>
          )}
          <Button danger size="small" icon={<DeleteOutlined />} onClick={() => handleDeleteCourse(record.id, record.title)} style={{ background: '#ff4d4f', borderColor: '#ff4d4f', color: 'white', fontWeight: 'bold' }}>Supprimer</Button>
        </Space>
      ),
    },
  ];

  const handleEditCourse = (courseId) => {
    setEditingCourseId(courseId);
    setEditModalVisible(true);
  };

  const renderPurchasesContent = () => {
    return (
      <div>
        {purchaseStats && (
          <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
            <Col xs={24} sm={12} lg={6}>
              <Card bordered={false} style={{ borderLeft: '4px solid #1890ff', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                <Statistic title="Total Paiements" value={purchaseStats.totalPurchases} prefix={<ShoppingCartOutlined style={{ color: '#1890ff' }} />} valueStyle={{ color: '#1890ff' }} />
              </Card>
            </Col>
            <Col xs={24} sm={12} lg={6}>
              <Card bordered={false} style={{ borderLeft: '4px solid #52c41a', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                <Statistic title="Revenu Total" value={purchaseStats.totalRevenue.toFixed(2)} prefix={<DollarOutlined style={{ color: '#52c41a' }} />} suffix="$" valueStyle={{ color: '#52c41a' }} />
              </Card>
            </Col>
            <Col xs={24} sm={12} lg={6}>
              <Card bordered={false} style={{ borderLeft: '4px solid #faad14', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                <Statistic title="30 derniers jours" value={purchaseStats.last30Days} prefix={<RiseOutlined style={{ color: '#faad14' }} />} valueStyle={{ color: '#faad14' }} />
              </Card>
            </Col>
            <Col xs={24} sm={12} lg={6}>
              <Card bordered={false} style={{ borderLeft: '4px solid #eb2f96', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                <Statistic title="Paiements réussis" value={purchaseStats.byStatus['succeeded'] || 0} prefix={<CheckCircleOutlined style={{ color: '#eb2f96' }} />} valueStyle={{ color: '#eb2f96' }} />
              </Card>
            </Col>
          </Row>
        )}
        <Card bordered={false} style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
          <Table columns={purchasesColumns} dataSource={purchases} rowKey="id" loading={loading} scroll={{ x: 1400 }} pagination={{ pageSize: 20 }} />
        </Card>
      </div>
    );
  };

  const renderInstructorsContent = () => {
    return (
      <div>
        {userStats && (
          <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
            <Col xs={24} md={8}>
              <Card bordered={false} style={{ borderLeft: '4px solid #722ed1', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                <Statistic title="Total Instructeurs" value={userStats.totalInstructors} prefix={<TeamOutlined style={{ color: '#722ed1' }} />} valueStyle={{ color: '#722ed1', fontSize: '28px' }} />
              </Card>
            </Col>
            <Col xs={24} md={8}>
              <Card bordered={false} style={{ borderLeft: '4px solid #52c41a', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                <Statistic title="Actifs" value={instructors.filter(i => i.isActivated).length} prefix={<UserAddOutlined style={{ color: '#52c41a' }} />} valueStyle={{ color: '#52c41a', fontSize: '28px' }} />
              </Card>
            </Col>
            <Col xs={24} md={8}>
              <Card bordered={false} style={{ borderLeft: '4px solid #1890ff', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                <Statistic title="Total Cours Créés" value={instructors.reduce((sum, i) => sum + (i.coursesCount || 0), 0)} prefix={<BookOutlined style={{ color: '#1890ff' }} />} valueStyle={{ color: '#1890ff', fontSize: '28px' }} />
              </Card>
            </Col>
          </Row>
        )}
        <Card bordered={false} style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
          <Table columns={usersColumns} dataSource={instructors} rowKey="id" loading={loading} scroll={{ x: 1200 }} pagination={{ pageSize: 20 }} />
        </Card>
      </div>
    );
  };

  const renderStudentsContent = () => {
    return (
      <div>
        {userStats && (
          <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
            <Col xs={24} md={8}>
              <Card bordered={false} style={{ borderLeft: '4px solid #13c2c2', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                <Statistic title="Total Étudiants" value={userStats.totalStudents} prefix={<UserOutlined style={{ color: '#13c2c2' }} />} valueStyle={{ color: '#13c2c2', fontSize: '28px' }} />
              </Card>
            </Col>
            <Col xs={24} md={8}>
              <Card bordered={false} style={{ borderLeft: '4px solid #52c41a', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                <Statistic title="Actifs" value={students.filter(s => s.isActivated).length} prefix={<CheckCircleOutlined style={{ color: '#52c41a' }} />} valueStyle={{ color: '#52c41a', fontSize: '28px' }} />
              </Card>
            </Col>
            <Col xs={24} md={8}>
              <Card bordered={false} style={{ borderLeft: '4px solid #faad14', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                <Statistic title="Total Cours Achetés" value={students.reduce((sum, s) => sum + (s.purchasesCount || 0), 0)} prefix={<TrophyOutlined style={{ color: '#faad14' }} />} valueStyle={{ color: '#faad14', fontSize: '28px' }} />
              </Card>
            </Col>
          </Row>
        )}
        <Card bordered={false} style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
          <Table columns={usersColumns} dataSource={students} rowKey="id" loading={loading} scroll={{ x: 1200 }} pagination={{ pageSize: 20 }} />
        </Card>
      </div>
    );
  };

  const renderPlanPurchasesContent = () => {
    return (
      <div>
        {planPurchaseStats && (<Row gutter={[16, 16]} style={{ marginBottom: 24 }}></Row>)}
        <Card bordered={false} style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
          <Table columns={planPurchasesColumns} dataSource={planPurchases} rowKey="id" loading={loading} scroll={{ x: 1400 }} pagination={{ pageSize: 20 }} />
        </Card>
      </div>
    );
  };

  const renderCourseDetails = () => {
    if (!selectedCourse) {
      return <Card><p style={{ textAlign: "center", color: "#999" }}>Sélectionnez un cours dans le tableau pour voir ses détails</p></Card>;
    }
    return (
      <Card title={
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span>Détails du cours: {selectedCourse.title}</span>
          {!selectedCourse.approved && (
            <Space>
              <Button type="primary" icon={<CheckCircleOutlined />} onClick={() => handleApproveClick(selectedCourse)}>Approuver ce cours</Button>
              <Button danger icon={<CloseCircleOutlined />} onClick={() => handleReject(selectedCourse.id)}>Rejeter</Button>
            </Space>
          )}
        </div>
      } loading={loading}>
        <Row gutter={[24, 24]}>
          <Col xs={24} md={8}>
            <Image src={selectedCourse.image} alt={selectedCourse.title} style={{ width: "100%", borderRadius: 8 }} placeholder={<div style={{ height: 200, background: "#f0f0f0" }} />} />
          </Col>
          <Col xs={24} md={16}>
            <Descriptions bordered column={2}>
              <Descriptions.Item label="ID" span={1}>{selectedCourse.id}</Descriptions.Item>
              <Descriptions.Item label="Statut" span={1}><Tag color={selectedCourse.approved ? "green" : "orange"}>{selectedCourse.approved ? "Approuvé" : "En attente"}</Tag></Descriptions.Item>
              <Descriptions.Item label="Prix actuel" span={1}>{selectedCourse.latest_price?.toFixed(2)} $</Descriptions.Item>
              <Descriptions.Item label="Prix régulier" span={1}>{selectedCourse.before_price?.toFixed(2)} $</Descriptions.Item>
              <Descriptions.Item label="Nombre de leçons" span={1}>{selectedCourse.lessons}</Descriptions.Item>
              <Descriptions.Item label="Durée totale" span={1}>{selectedCourse.duration}</Descriptions.Item>
              <Descriptions.Item label="Durée d'accès" span={1}>{selectedCourse.access_time}</Descriptions.Item>
              <Descriptions.Item label="Catégorie" span={1}>{selectedCourse.categoryLibelle || selectedCourse.category?.libelle || "Non définie"}</Descriptions.Item>
              <Descriptions.Item label="Sous-catégorie" span={2}>{selectedCourse.subcategoryLibelle || selectedCourse.subcategory?.libelle || "Non définie"}</Descriptions.Item>
              <Descriptions.Item label="Description courte" span={2}>{selectedCourse.short_desc || "Aucune description"}</Descriptions.Item>
              {selectedCourse.overview && (<Descriptions.Item label="Aperçu" span={2}><div dangerouslySetInnerHTML={{ __html: selectedCourse.overview }} /></Descriptions.Item>)}
              {selectedCourse.requirements && (<Descriptions.Item label="Prérequis" span={2}><div dangerouslySetInnerHTML={{ __html: selectedCourse.requirements }} /></Descriptions.Item>)}
              {selectedCourse.what_you_will_learn && (<Descriptions.Item label="Ce que vous allez apprendre" span={2}><div dangerouslySetInnerHTML={{ __html: selectedCourse.what_you_will_learn }} /></Descriptions.Item>)}
              {selectedCourse.who_is_this_course_for && (<Descriptions.Item label="Public cible" span={2}><div dangerouslySetInnerHTML={{ __html: selectedCourse.who_is_this_course_for }} /></Descriptions.Item>)}
            </Descriptions>
          </Col>
        </Row>
      </Card>
    );
  };

  const renderCoursesContent = () => {
    const dataSource = selectedMenu === "courses" ? courses : pendingCourses;
    const approvedCount = courses.filter(c => c.approved).length;
    const pendingCount = pendingCourses.length;
    const totalCount = courses.length;
    return (
      <Tabs activeKey={activeTab} onChange={setActiveTab}>
        <TabPane tab={<Badge count={totalCount} color="#1890ff" offset={[10, 0]}><span style={{ paddingRight: 20 }}><BookOutlined style={{ marginRight: 8 }} />Liste des cours</span></Badge>} key="1">
          <Card bordered={false} style={{ boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }} title={
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div><BookOutlined style={{ marginRight: 8, color: '#1890ff' }} />Gestion des Cours</div>
              <div style={{ display: 'flex', gap: 8 }}>
                <Tag color="success" style={{ margin: 0 }}>{approvedCount} Approuvés</Tag>
                <Tag color="warning" style={{ margin: 0 }}>{pendingCount} En attente</Tag>
                <Tag color="blue" style={{ margin: 0 }}>{totalCount} Total</Tag>
              </div>
            </div>
          }>
            <Table columns={coursesColumns} dataSource={dataSource} rowKey="id" loading={loading} scroll={{ x: 1400 }}
              pagination={{ pageSize: 10, showSizeChanger: true, showQuickJumper: true, showTotal: (total, range) => `${range[0]}-${range[1]} sur ${total} cours` }}
              rowClassName={(record) => record.approved ? 'approved-row' : 'pending-row'} />
          </Card>
        </TabPane>
        <TabPane tab={<Badge count={selectedCourse ? 1 : 0} color="#52c41a" offset={[10, 0]}><span style={{ paddingRight: 20 }}><EyeOutlined style={{ marginRight: 8 }} />Détails du cours</span></Badge>} key="2">
          {renderCourseDetails()}
        </TabPane>
      </Tabs>
    );
  };

  const renderContent = () => {
    switch (selectedMenu) {
      case "dashboard":
        return (
          <div>
            <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
              <Col xs={24} sm={12} lg={6}>
                <Card bordered={false} style={{ borderLeft: '4px solid #1890ff', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                  <Statistic title="Total Cours" value={courses.length} prefix={<BookOutlined style={{ color: '#1890ff' }} />} valueStyle={{ color: '#1890ff' }} />
                </Card>
              </Col>
              <Col xs={24} sm={12} lg={6}>
                <Card bordered={false} style={{ borderLeft: '4px solid #faad14', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                  <Statistic title="Cours en attente" value={pendingCourses.length} prefix={<CloseCircleOutlined style={{ color: '#faad14' }} />} valueStyle={{ color: '#faad14' }} />
                </Card>
              </Col>
              <Col xs={24} sm={12} lg={6}>
                <Card bordered={false} style={{ borderLeft: '4px solid #52c41a', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                  <Statistic title="Cours approuvés" value={courses.filter((c) => c.approved).length} prefix={<CheckCircleOutlined style={{ color: '#52c41a' }} />} valueStyle={{ color: '#52c41a' }} />
                </Card>
              </Col>
              <Col xs={24} sm={12} lg={6}>
                <Card bordered={false} style={{ borderLeft: '4px solid #eb2f96', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                  <Statistic title="Total Utilisateurs" value={(userStats?.totalInstructors || 0) + (userStats?.totalStudents || 0)} prefix={<UserOutlined style={{ color: '#eb2f96' }} />} valueStyle={{ color: '#eb2f96' }} />
                </Card>
              </Col>
            </Row>
          </div>
        );

      case "courses":
        return (<div><h2 style={{ marginBottom: 24 }}>Tous les Cours</h2>{renderCoursesContent()}</div>);

      case "pending-courses":
        return (<div><h2 style={{ marginBottom: 24 }}>Cours en attente d'approbation</h2>{renderCoursesContent()}</div>);

      case "purchases":
        return (<div><h2 style={{ marginBottom: 24 }}>Gestion des Paiements</h2>{renderPurchasesContent()}</div>);

      case "instructors":
        return (<div><h2 style={{ marginBottom: 24 }}>Gestion des Instructeurs</h2>{renderInstructorsContent()}</div>);

      case "students":
        return (<div><h2 style={{ marginBottom: 24 }}>Gestion des Étudiants</h2>{renderStudentsContent()}</div>);

      case "user-management":
        return (<div><h2 style={{ marginBottom: 24 }}>Gestion des Utilisateurs</h2><UserManagement /></div>);

      case "plan-purchases":
        return (<div><h2 style={{ marginBottom: 24 }}>Gestion des Achats de Plans</h2>{renderPlanPurchasesContent()}</div>);

      case "live-trainings":
        return (<div><h2 style={{ marginBottom: 24 }}>🔴 Gestion des Formations Live</h2><LiveTrainingsAdmin /></div>);

      default:
        return <h2>Welcome to Admin Dashboard</h2>;
    }
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider
        breakpoint="lg"
        collapsedWidth="0"
        style={{
          boxShadow: '2px 0 8px rgba(0,0,0,0.15)',
          // ✅ Couleur de fond Nomidya (bleu) — aligné avec le logo et le header
          background: 'linear-gradient(180deg, #0054A6 0%, #003B75 100%)',
        }}
      >
        <div
          style={{
            height: 64,
            margin: 16,
            // ✅ Logo container avec accent orange Nomidya
            background: 'linear-gradient(135deg, rgba(232, 134, 12, 0.25) 0%, rgba(255, 255, 255, 0.15) 100%)',
            border: '1px solid rgba(232, 134, 12, 0.3)',
            borderRadius: 10,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            fontSize: '18px',
            fontWeight: 'bold',
            letterSpacing: '0.5px',
            textShadow: '0 1px 2px rgba(0,0,0,0.2)'
          }}
        >
          NOMIDYA ADMIN
        </div>

        {/* ✅ Styles personnalisés pour le menu (bleu Nomidya + accent orange) */}
        <style>{`
          .nomidya-admin-menu.ant-menu-dark,
          .nomidya-admin-menu.ant-menu-dark .ant-menu-sub {
            background: transparent !important;
          }
          .nomidya-admin-menu.ant-menu-dark .ant-menu-item {
            color: rgba(255, 255, 255, 0.85) !important;
            border-radius: 6px !important;
            margin: 4px 8px !important;
            width: calc(100% - 16px) !important;
            transition: all 0.2s ease !important;
          }
          .nomidya-admin-menu.ant-menu-dark .ant-menu-item:hover {
            background: rgba(232, 134, 12, 0.2) !important;
            color: #fff !important;
          }
          .nomidya-admin-menu.ant-menu-dark .ant-menu-item-selected {
            background: linear-gradient(135deg, #E8860C 0%, #d97706 100%) !important;
            color: #fff !important;
            font-weight: 600 !important;
            box-shadow: 0 4px 12px rgba(232, 134, 12, 0.4) !important;
          }
          .nomidya-admin-menu.ant-menu-dark .ant-menu-item-selected::after {
            display: none !important;
          }
          .nomidya-admin-menu.ant-menu-dark .ant-menu-item .anticon {
            font-size: 16px !important;
          }
        `}</style>

        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={["dashboard"]}
          onClick={(e) => setSelectedMenu(e.key)}
          style={{ borderRight: 0, marginTop: 8 }}
          className="nomidya-admin-menu"
        >
          <Menu.Item key="dashboard" icon={<DashboardOutlined />}>Dashboard</Menu.Item>
          <Menu.Item key="courses" icon={<BookOutlined />}>Tous les Cours</Menu.Item>
          <Menu.Item key="pending-courses" icon={<BookOutlined />}>Cours en attente</Menu.Item>
          <Menu.Item key="purchases" icon={<DollarOutlined />}>Paiements</Menu.Item>
          <Menu.Item key="instructors" icon={<TeamOutlined />}>Instructeurs</Menu.Item>
          <Menu.Item key="students" icon={<UserOutlined />}>Étudiants</Menu.Item>
          <Menu.Item key="user-management" icon={<TeamOutlined />}>Gestion Utilisateurs</Menu.Item>
          <Menu.Item key="plan-purchases" icon={<TrophyOutlined />}>Achats de Plans</Menu.Item>
          <Menu.Item key="live-trainings" icon={<VideoCameraOutlined />}>🔴 Formations Live</Menu.Item>

          {/* ✅ Certificats → ouvre une modal (comme ModeratorCourses) */}
          <Menu.Item key="manual-certificates" icon={<SafetyCertificateOutlined />}>
            Certificats
          </Menu.Item>
        </Menu>
      </Sider>

      <Layout>
        <Header style={{ padding: '0 24px', background: '#fff', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
          <Button type="primary" icon={<SettingOutlined />} onClick={() => setIsManagementModalVisible(true)} style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', border: 'none', height: '40px', borderRadius: '8px', fontWeight: 'bold' }}>
            Gestion Générale
          </Button>
        </Header>

        <Content style={{ margin: "24px 16px", padding: 24, background: '#f0f2f5' }}>
          {renderContent()}
        </Content>

        <Footer style={{ textAlign: "center", background: '#fff' }}>©2024 Nomidya. Tous droits réservés.</Footer>

        <CourseEditModal visible={editModalVisible} courseId={editingCourseId}
          onClose={() => { setEditModalVisible(false); setEditingCourseId(null); }}
          onSuccess={() => {
            if (selectedMenu === "courses") loadAllCourses();
            else if (selectedMenu === "pending-courses") loadPendingCourses();
          }} />
      </Layout>

      {/* ====== MODAL CERTIFICATS — EXACTEMENT comme dans ModeratorCourses ====== */}
      {/*    width="98%", style top:10, body padding 20, Tabs intérieures size="small"     */}
      {/*    ✅ Pas de sélecteur de cours : le composant CertificateGenerator charge      */}
      {/*       automatiquement le dernier template depuis la BDD via useEffect           */}
      <Modal
        open={isCertificatesModalVisible}
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <SafetyCertificateOutlined style={{ fontSize: '20px' }} />
            <span>Gestion des certificats</span>
          </div>
        }
        footer={null}
        width="98%"
        style={{ top: 10 }}
        bodyStyle={{
          height: 'calc(100vh - 120px)',
          overflowY: 'auto',
          padding: '20px'
        }}
        onCancel={() => {
          setIsCertificatesModalVisible(false);
        }}
        destroyOnClose
        maskClosable={false}
      >
        <div style={{ position: "relative" }}>
          {/* ✅ EXACTEMENT le même pattern Tabs que ModeratorCourses */}
          {/*    Le composant CertificateGenerator se débrouille avec son useEffect */}
          {/*    pour charger le dernier template existant en BDD */}
          <Tabs defaultActiveKey="template" type="card" size="small">
            <TabPane tab={<span><SettingOutlined /> Modèle du certificat</span>} key="template">
              <CertificateGenerator
                studentName="Nom"
                courseTitle="Cours"
                courseId={courses[0]?.id}
              />
            </TabPane>

            <TabPane tab={<span><ContactsOutlined /> Génération manuelle</span>} key="manual">
              <ManualCertificateGenerator />
            </TabPane>

            {/* ✅ NOUVEAU : 3ème onglet — Liste des certificats envoyés (admin) */}
            <TabPane
              tab={
                <span>
                  <UnorderedListOutlined /> Certificats envoyés
                </span>
              }
              key="sent"
            >
              <SentCertificatesManager />
            </TabPane>
          </Tabs>
        </div>
      </Modal>

      <Modal title={`Approuver le cours: ${selectedCourse?.title}`} visible={modalVisible} onOk={handleApprove} onCancel={() => setModalVisible(false)} okText="Approuver" cancelText="Annuler" width={600}>
        <Form form={form} layout="vertical">
          <Form.Item label="Prix actuel ($)" name="latestPrice" rules={[{ required: true, message: "Veuillez entrer le prix actuel" }]}>
            <InputNumber min={0} step={0.01} style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item label="Prix régulier ($)" name="beforePrice" rules={[{ required: true, message: "Veuillez entrer le prix régulier" }]}>
            <InputNumber min={0} step={0.01} style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item label="Durée d'accès" name="accessTime" rules={[{ required: true, message: "Veuillez sélectionner la durée" }]}>
            <Select>
              <Option value="À vie">À vie</Option>
              <Option value="3 mois">3 mois</Option>
              <Option value="6 mois">6 mois</Option>
              <Option value="1 an">1 an</Option>
            </Select>
          </Form.Item>
        </Form>
      </Modal>

      <Modal open={isManagementModalVisible} title={
        <div style={{ fontSize: '20px', fontWeight: 'bold', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
          Gestion Générale
        </div>
      } footer={null} width="90%" onCancel={() => setIsManagementModalVisible(false)} style={{ top: 20 }} destroyOnClose maskClosable={false}>
        <Tabs defaultActiveKey="1" tabPosition="top" type="line">
          <TabPane tab={<span style={{ fontSize: '15px' }}><SettingOutlined style={{ color: "#13c2c2", fontSize: '18px' }} /> Gestion des Plans</span>} key="1"><PlanManager /></TabPane>
          <TabPane tab={<span style={{ fontSize: '15px' }}><FileImageOutlined style={{ color: "#eb2f96", fontSize: '18px' }} /> Actualités</span>} key="2"><NewsManager /></TabPane>
          <TabPane tab={<span style={{ fontSize: '15px' }}><ContactsOutlined style={{ color: "#1890ff", fontSize: '18px' }} /> Demandes de Contact</span>} key="3"><SalesRequestManager /></TabPane>
          <TabPane tab={<span style={{ fontSize: '15px' }}><TeamOutlined style={{ color: "#722ed1", fontSize: '18px' }} /> Candidatures Instructeur</span>} key="4"><InstructorRequestManager /></TabPane>
          <TabPane tab={<span style={{ fontSize: '15px' }}><AppstoreOutlined style={{ color: "#fa8c16", fontSize: '18px' }} /> Catégories</span>} key="5"><CategoryManager /></TabPane>
        </Tabs>
      </Modal>
    </Layout>
  );
};

export default BoardAdmin;